import { loadQuestJson } from "../../features/requests";
import { getCurrentQuestAchievement } from "../../features/stats";
import { QUEST_VIEW_NAME } from "../constants";
import { QuestData, QuestEntry } from "../types";
import { getViewData, setViewData } from "../views";
import { createQuestUrl } from "./questid";

export async function loadQuestData(questData : QuestData) : Promise<void> {
  const viewData = getViewData(QUEST_VIEW_NAME);
  viewData.data = questData;
  setViewData(QUEST_VIEW_NAME, viewData);
}

export async function getQuestDataForId(questId : string) : Promise<QuestData> {
  const questFileUrl : string = createQuestUrl(questId);
  console.log('load quest:', questFileUrl)
  return await loadQuestJson(questFileUrl);  
}

export async function checkNextWaypoint(questId, projectId, currentQuestIndex) {
  const questData = await getQuestDataForId(questId);
  const nextWaypoint = questData.path[currentQuestIndex];
  if (nextWaypoint && nextWaypoint.projectCode === projectId) {
    return true;
  }
  return false;
}

export function getQuestList() {
  const viewData = getViewData(QUEST_VIEW_NAME);
  const completeList = viewData.cfg?.quests;

  console.log('complete list', completeList);
  if (!completeList) {
    return [];
  }

  let questList = completeList.filter((quest : QuestEntry) => {
    return quest.listed && (quest.permittedRoles === null || quest.permittedRoles === undefined) && !quest.achievable;
  });

  //TODO: handle quests with roles

  const achievedQuestList = completeList.filter((quest : QuestEntry) => {
    return !quest.listed && quest.achievable && getCurrentQuestAchievement(quest.id) > -1;
  });
  questList = questList.concat(achievedQuestList);

  console.log('quest list', questList);
  return questList;
}